itsoftApp.createModule("accordion", function() {
    var module = this;
    var initialized = false;
    var queue = [];

    var initQueue = function() {
        var qLen = queue.length;
        if (!qLen) {
            return;
        }

        DEBUG && console.log("[module testing] initQueue function fired, queue.length: " + qLen);

        while (queue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            queue.shift()();
        }
    };

    var loadAndInit = function() {
        var f = function() {
            initQueue();
        };

        f();
    };

    var addEvent = function(func) {
        if (typeof func !== "function") {
            return;
        }
        queue.push(func);
        itsoftApp.modules.pageLoad.addEvent(loadAndInit);
    };

    var initAccordions = function () {
        var self;

        $('.js-accordion .js-accordion-head').click(function(evt) {
            evt.preventDefault();

            self = $(this);

            if($(this).hasClass('js-accordion-head--active')) {
                self.removeClass('js-accordion-head--active');
                $(this).next('.js-accordion-content').slideUp(400);
            }
            else {
                var activeHead = $('.js-accordion .js-accordion-head--active');

                activeHead.removeClass('js-accordion-head--active');
                activeHead.next('.js-accordion-content').slideUp(400);
                self.addClass('js-accordion-head--active');
                $(this).next('.js-accordion-content').slideDown(400);
            }    
        });
    }

    module.callback = function () {
        if (!initialized) {
            addEvent(initAccordions);
            initialized = true;
        }
    }
})